import { createFileRoute, Navigate, Outlet, redirect, useRouterState } from "@tanstack/react-router"
import { shouldRouteDashboardHostToCms } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"
import { isSupportedLocale } from "@utils/locale"

export const Route = createFileRoute("/$locale")({
  beforeLoad: async ({ params, location }) => {
    if (shouldRouteDashboardHostToCms(await currentRequestHostname(), location.pathname)) {
      throw redirect({ href: "/dashboard" })
    }
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  component: LocaleRoute,
})

function LocaleRoute() {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  if (typeof window !== "undefined" && shouldRouteDashboardHostToCms(window.location.hostname, pathname)) {
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    )
  }

  return <Outlet />
}
